var EditInPlace_module_default = {
	controls: "_controls_17lij_8",
	"button-group": "_button-group_17lij_18"
};
//#endregion
export { EditInPlace_module_default as default };

//# sourceMappingURL=EditInPlace.module.js.map